const dataAbout = {
    section_title: "About.section_title",
    text_paragraphs: [
        {
            paragraph: "About.1"
        },
        {
            paragraph: "About.2"
        },
        {
            paragraph: "About.3"
        },
        {
            paragraph: "About.4"
        }],
    tech_paragraphs: ["JavaScript", "TypeScript", "jQuery", "React", "HTML", "CSS", "Less", "Sass", "Material UI", "Bootstrap"]
}

export default dataAbout